"use client";
import { useI18n } from "@/components/providers/I18nProvider";

/** Interactive marketing receives the current locale, not all source catalogs. */
export function useMarketingText() {
  return useI18n().translateMarketing;
}
